import React from 'react';
import { motion } from 'framer-motion';
import { PROJECTS_SECTION, PROJECTS } from '../lib/content';
import { Reveal } from './Reveal';
export function ProjectsGallery() {
  const duplicatedProjects = [...PROJECTS, ...PROJECTS];
  return <section id="proyectos" className="w-full bg-gradient-to-b from-[#FFF5ED] to-white py-16 sm:py-24 pt-[23px] pb-[0px]" data-id="element-480" data-mp="2y052hq2z1bw">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-481" data-mp="3u88kynamy7hb">
        <Reveal className="text-center" data-id="element-482" data-mp="3q52htoitkwf2">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-1.5 font-display text-[10px] font-black uppercase tracking-widest text-[#FF6B35] shadow-sm sm:text-xs" data-id="element-483" data-mp="3q63rppo3ncv7">
            {PROJECTS_SECTION.badge}
          </span>
          <h2 className="mx-auto mt-6 max-w-sm text-4xl font-black leading-[1.1] text-[#1C3587] sm:max-w-none sm:text-5xl font-[Barlow,_sans-serif]" data-id="element-484" data-mp="3bgfvh2urz4ec">
            {PROJECTS_SECTION.title}
            <br data-id="element-485" data-mp="32egajzgn3g64" />
            <span className="text-[#FF8C22]" data-id="element-486" data-mp="32fzqfoydvp7d">{PROJECTS_SECTION.titleHighlight}</span>
          </h2>
          <p className="mx-auto mt-4 max-w-md font-display text-[15px] font-bold leading-snug text-[#4A5568] sm:text-lg" data-id="element-487" data-mp="1gcamqowoj2it">
            {PROJECTS_SECTION.description}
          </p>
        </Reveal>

        <div className="relative mt-10 w-full overflow-hidden py-4 sm:mt-14" data-id="element-488" data-mp="16g7indi9ott8">
          {/* Gradient masks for smooth fade in/out at edges */}
          <div className="pointer-events-none absolute bottom-0 left-0 top-0 z-10 w-12 bg-gradient-to-r from-white to-transparent sm:w-32" data-id="element-489" data-mp="1bbmygazu4zsa" />
          <div className="pointer-events-none absolute bottom-0 right-0 top-0 z-10 w-12 bg-gradient-to-l from-white to-transparent sm:w-32" data-id="element-490" data-mp="241lpgbxlb6zl" />

          <motion.div className="flex w-max gap-4 sm:gap-6" animate={{
          x: ['-50%', '0%']
        }} transition={{
          duration: 40,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-491" data-mp="1q4yeh58sygao">
            {duplicatedProjects.map((project, i) => <figure key={`${project.title}-${i}`} className="group relative h-[240px] w-[240px] flex-none overflow-hidden rounded-[24px] border-[4px] border-white bg-white shadow-[0_8px_24px_rgba(0,0,0,0.08)] sm:h-[320px] sm:w-[320px]" data-id="element-492" data-mp="iptqzo3lgwz6" data-mpi={i}>
                <img src={project.image} alt={project.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" data-id="element-493" data-mp="2gde9at9hlkp8" />
              </figure>)}
          </motion.div>
        </div>

        <Reveal className="mx-auto mt-10 max-w-2xl sm:mt-14" data-id="element-494" data-mp="22lhnt82bq91t">
          <div className="flex items-center gap-4 rounded-2xl border border-[#FF8C22] bg-[#FFF5ED] p-4 shadow-sm sm:p-5" data-id="element-495" data-mp="22n2h6ucwjly3">
            <span className="flex h-12 w-12 flex-none items-center justify-center rounded-full bg-[#FF8C22] text-xl text-white shadow-sm sm:h-14 sm:w-14 sm:text-2xl" aria-hidden="true" data-id="element-496" data-mp="1xohe8n69mo5y">
              ✨
            </span>
            <p className="font-display text-[13px] font-black leading-tight text-[#1C3587] sm:text-[15px]" data-id="element-497" data-mp="3n12t7jbdjap8">
              {PROJECTS_SECTION.tagline}
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}